import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { buildBreadcrumbList } from '../lib/structuredData';
import { RocketIcon, GraduationCapIcon, UsersIcon, HomeIcon, ArrowRightIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const SollicitatiePage: React.FC = () => {
  const benefits = [{
    icon: <RocketIcon className="h-6 w-6" data-id="element-2581" data-mp="181skqhwfpxsg" />,
    title: 'Inspirerende projecten',
    description: 'Werk aan websites en digitale oplossingen voor uiteenlopende bedrijven.'
  }, {
    icon: <GraduationCapIcon className="h-6 w-6" data-id="element-2582" data-mp="1gvns7wl140b9" />,
    title: 'Ruimte voor ontwikkeling',
    description: 'Leer nieuwe skills en groei in je rol. Wij investeren in jouw toekomst.'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-2583" data-mp="1qtlfagr5jr2a" />,
    title: 'Hecht team',
    description: 'Klein team, korte lijnen. Jouw ideeën tellen mee vanaf dag één.'
  }, {
    icon: <HomeIcon className="h-6 w-6" data-id="element-2584" data-mp="3eiekhc0i9np7" />,
    title: 'Hybride werken',
    description: 'Flexibel werken vanuit kantoor of thuis. Wij vertrouwen op resultaat.'
  }];
  const vacancies = [{
    title: 'Stage Design',
    tags: ['UI/UX', 'Figma', 'Webdesign', 'Branding'],
    type: 'Stage',
    slug: 'stage-design',
    status: 'bezet'
  }, {
    title: 'Stage Account Manager',
    tags: ['Sales', 'Klantcontact', 'Communicatie', 'Project coördinatie'],
    type: 'Stage',
    slug: 'stage-account-manager',
    status: 'open'
  }, {
    title: 'Stage Developer',
    tags: ['React', 'TypeScript', 'WordPress', 'Tailwind CSS'],
    type: 'Stage',
    slug: 'stage-developer',
    status: 'binnenkort',
    opensAt: '2026-09-05T00:00:00'
  }];
  const processSteps = [{
    title: 'Kennismaking',
    description: 'We plannen een informeel gesprek om elkaar te leren kennen.'
  }, {
    title: 'Opdracht & gesprek',
    description: 'Je maakt een kleine opdracht en we bespreken je aanpak.'
  }, {
    title: 'Aanbod',
    description: 'Past het? Dan doen we je een aanbod waar je blij van wordt.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-2585" data-mp="2ea82y8hi58l4">
      <SEO title="Werken bij Noord Digital | Vacatures & Stages" description="Kom werken bij Noord Digital. Bouw mee aan websites, SEO en hosting voor ambitieuze bedrijven. Bekijk onze vacatures en stageplekken." keywords="werken bij noord digital, vacatures webdeveloper, stage webdesign, seo specialist vacature, erkend leerbedrijf" canonical="https://noorddigital.nl/sollicitatie" jsonLd={buildBreadcrumbList([{
      name: 'Vacatures',
      path: '/sollicitatie'
    }])} data-id="element-2586" data-mp="2ecareo30atnq" />
      <Header data-id="element-2587" data-mp="1go0rcems6fz9" />

      {/* Hero Section */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-24 relative overflow-hidden" data-id="element-2588" data-mp="1llaned4odpw2">
        <div className="absolute inset-0 opacity-20" data-id="element-2589" data-mp="3azywo5hyyrpv">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-2590" data-mp="3aye3aj7e5etl"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-2591" data-mp="14a5gpb1wq53u">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-2592" data-mp="zb29bjygfmsp">
            {/* Left side - Main content */}
            <div className="lg:col-span-7" data-id="element-2593" data-mp="19bl06yofs3k4">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-2594" data-mp="19aje7z5vtwnm">
                Kom werken bij Noord Digital
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg md:text-xl leading-relaxed max-w-2xl" data-id="element-2595" data-mp="1s2uavb9y0yda">
                Bouw mee aan websites, SEO en hosting voor ambitieuze bedrijven.
                Wij zoeken talent dat wil groeien.
              </motion.p>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-2596" data-mp="92uye7sb8nyu">
                <a href="#vacatures" className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-bold rounded-xl hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl" data-id="element-2597" data-mp="3hiern6sze6dw">
                  Bekijk vacatures
                </a>
              </motion.div>
            </div>

            {/* Right side - Visuals */}
            <div className="lg:col-span-5" data-id="element-2598" data-mp="2tskgctob8pvr">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-3xl p-8 shadow-2xl relative flex flex-col items-center text-center" data-id="element-2599" data-mp="2ysgl4v4u0lcd">
                <div className="w-32 h-32 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full mb-6 p-2 shadow-inner border-4 border-white" data-id="element-2600" data-mp="16v2rc6z5mm4z">
                  <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden mascotte" className="w-full h-full object-cover rounded-full" data-id="element-2601" data-mp="wy7v5uqcsxtv" />
                </div>

                <h3 className="font-bold text-[#111827] text-xl mb-4" data-id="element-2602" data-mp="o5mnb9o9gbjt">
                  Word onderdeel van ons team
                </h3>

                <div className="w-full h-px bg-gray-100 my-4" data-id="element-2603" data-mp="j8mguxni16s6"></div>

                <img src="https://cdn.magicpatterns.com/uploads/1aHtpkWESLeaWQNYKA51qz/WhatsApp_Image_2026-02-28_at_14.34.29.jpg" alt="S-BB Erkend Leerbedrijf" className="w-48 h-auto object-contain mt-2" data-id="element-2604" data-mp="e88d3rsxkizy" />
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Waarom Noord Digital Section */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-2605" data-mp="4lnv9jbbp6ld">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2606" data-mp="3mqhffuv3q1my">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2607" data-mp="3qrb08fd8z0bm">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2608" data-mp="3qruijx6t7qq6">
              Waarom werken bij Noord Digital?
            </motion.h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2609" data-mp="dk97yxu45re8">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#F7F8FA] rounded-2xl p-8 hover:shadow-md transition-all duration-300 border border-transparent hover:border-gray-200" data-id="element-2610" data-mp="11adaf1vkfl3n" data-mpi={index}>
                <div className="flex items-start gap-5" data-id="element-2611" data-mp="30g8xgqlrfeeb">
                  <div className="flex-shrink-0 w-14 h-14 bg-[#007AFF] bg-opacity-10 rounded-xl flex items-center justify-center text-[#007AFF]" data-id="element-2612" data-mp="2viqxvqtmubiz">
                    {benefit.icon}
                  </div>
                  <div data-id="element-2613" data-mp="22u1u1k16zs3j">
                    <h3 className="font-bold text-[#111827] text-xl mb-3" data-id="element-2614" data-mp="22uv4ow39v1qy">
                      {benefit.title}
                    </h3>
                    <p className="text-[#6B7280] leading-relaxed" data-id="element-2615" data-mp="2hozmecwcchkm">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Openstaande Vacatures Section */}
      <div id="vacatures" className="w-full bg-[#F7F8FA] py-20 md:py-24" data-id="element-2616" data-mp="3o6v54gruqwns">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2617" data-mp="1llir06i722o9">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2618" data-mp="1qj0zjvsaufvq">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2619" data-mp="1qh7tahlllxo9">
              Openstaande vacatures
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2620" data-mp="299iqpvxhh3ez">
              Zit jouw droombaan er niet tussen? Een open sollicitatie sturen
              mag altijd!
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2621" data-mp="ougtwas71dsx">
            {vacancies.map((vacancy, index) => {
            // Calculate simple countdown for 'binnenkort'
            let countdownText = '';
            if (vacancy.status === 'binnenkort' && vacancy.opensAt) {
              const targetDate = new Date(vacancy.opensAt);
              const now = new Date();
              const diffTime = Math.abs(targetDate.getTime() - now.getTime());
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              const months = Math.floor(diffDays / 30);
              const days = diffDays % 30;
              countdownText = `Opent over ${months > 0 ? `${months} maanden en ` : ''}${days} dagen`;
            }
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} whileHover={{
              y: -5
            }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col h-full relative overflow-hidden" data-id="element-2622" data-mp="ld2knipvtmg2" data-mpi={index}>
                  <div className="mb-6" data-id="element-2623" data-mp="23g4q04xbiocz">
                    <div className="flex justify-between items-start mb-4" data-id="element-2624" data-mp="23h6d57rlz1b2">
                      <span className="inline-block bg-blue-50 text-[#007AFF] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-2625" data-mp="1yowi5dbmzb1x">
                        {vacancy.type}
                      </span>
                      {vacancy.status === 'bezet' && <span className="inline-block bg-gray-100 text-gray-600 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-2626" data-mp="28eohekuokscq">
                          Op dit moment bezet
                        </span>}
                      {vacancy.status === 'open' && <span className="inline-block bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-2627" data-mp="s0g2ncg5jnbn">
                          Nu open
                        </span>}
                      {vacancy.status === 'binnenkort' && <span className="inline-block bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-2628" data-mp="2yq087rnnkbd3">
                          Binnenkort open
                        </span>}
                    </div>
                    <h3 className="font-bold text-[#111827] text-2xl mb-4" data-id="element-2629" data-mp="2ty8dd4xgrjh5">
                      {vacancy.title}
                    </h3>
                    <div className="flex flex-wrap gap-2 mb-4" data-id="element-2630" data-mp="2fxxkjwclfutc">
                      {vacancy.tags.map((tag, tagIndex) => <span key={tagIndex} className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-md" data-id="element-2631" data-mp="2kzeok0qdjxe5" data-mpi={tagIndex}>
                          {tag}
                        </span>)}
                    </div>
                    {vacancy.status === 'binnenkort' && <div className="bg-amber-50 text-amber-800 text-sm p-3 rounded-lg border border-amber-100 font-medium" data-id="element-2632" data-mp="496gqlkqxgsq">
                        ⏳ {countdownText}
                      </div>}
                  </div>

                  <div className="mt-auto pt-8" data-id="element-2633" data-mp="7rn40kza7g43">
                    <a href={`/vacature/${vacancy.slug}`} className={`flex items-center justify-center w-full font-semibold py-3 px-6 rounded-lg transition duration-300 group ${vacancy.status === 'open' ? 'bg-[#007AFF] hover:bg-[#005FCC] text-white' : 'bg-gray-100 hover:bg-gray-200 text-[#111827]'}`} data-id="element-2634" data-mp="7sf1608j1lwh">
                      {vacancy.status === 'open' ? 'Bekijk vacature' : 'Bekijk details'}
                      <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2635" data-mp="qh3jcefmld4k" />
                    </a>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>

      {/* Onze Cultuur Section */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-2636" data-mp="cqzz1t0b3thr">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2637" data-mp="codtfywz7o26">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-2638" data-mp="199e5gwm28wfz">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-2639" data-mp="14gl2ad68pw60">
              <h2 className="font-bold text-[#111827] mb-6 text-3xl md:text-4xl" data-id="element-2640" data-mp="2s3hayio2k1ok">
                Onze cultuur
              </h2>
              <p className="text-[#6B7280] text-lg leading-relaxed mb-6" data-id="element-2641" data-mp="313vxtmgolou6">
                Bij Noord Digital geloven we in een open, eerlijke en gedreven
                werksfeer. We werken hard voor onze klanten, maar vieren ook
                samen onze successen. Fouten maken mag, zolang we er maar van
                leren.
              </p>
              <p className="text-[#6B7280] text-lg leading-relaxed mb-8" data-id="element-2642" data-mp="3fu36jagvztho">
                We zijn een jong en dynamisch team dat altijd op zoek is naar de
                nieuwste ontwikkelingen in webdesign, SEO en techniek. Kennis
                delen staat bij ons centraal.
              </p>

              <div className="bg-[#F7F8FA] rounded-2xl p-6 border border-gray-100 flex items-start gap-6" data-id="element-2643" data-mp="3ttcn4b908pm6">
                <img src="https://cdn.magicpatterns.com/uploads/1aHtpkWESLeaWQNYKA51qz/WhatsApp_Image_2026-02-28_at_14.34.29.jpg" alt="S-BB Erkend Leerbedrijf" className="w-24 h-auto object-contain flex-shrink-0" data-id="element-2644" data-mp="3g4j8s5ob1gut" />
                <div data-id="element-2645" data-mp="3puvs5ukdv3zd">
                  <h4 className="font-bold text-[#111827] mb-2" data-id="element-2646" data-mp="3pxi3m5aea3mv">
                    Erkend Leerbedrijf
                  </h4>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-2647" data-mp="2x6ggni0gn3ss">
                    Noord Digital is een erkend leerbedrijf. Wij leiden
                    vakmensen op en bieden uitdagende stage- en leerplekken waar
                    je écht impact kunt maken.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative h-[400px] rounded-3xl overflow-hidden shadow-2xl" data-id="element-2648" data-mp="3285qiuby5bfa">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Team Noord Digital aan het werk" className="w-full h-full object-cover" data-id="element-2649" data-mp="oxs68147fixk" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-2650" data-mp="g0rk614lxwxa"></div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Sollicitatieproces Section */}
      <div className="w-full bg-[#F7F8FA] py-20 md:py-24 overflow-hidden" data-id="element-2651" data-mp="17rxl2js5jynm">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2652" data-mp="1cofqllvb4110">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2653" data-mp="ywhpnybr1bfx">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2654" data-mp="12yw5e9k4fv2z">
              Hoe verloopt het sollicitatieproces?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2655" data-mp="25a48weqe3yvn">
              We houden het graag simpel en persoonlijk. Geen eindeloze rondes,
              maar snel duidelijkheid.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-2656" data-mp="1hlbambmapexv">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0" data-id="element-2657" data-mp="1dl16z5lz70m6"></div>

            {processSteps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="relative z-10 bg-white rounded-2xl p-8 text-center shadow-lg border border-gray-100" data-id="element-2658" data-mp="13m24y5vpu385" data-mpi={index}>
                <div className="w-16 h-16 mx-auto bg-[#007AFF] text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-md border-4 border-white" data-id="element-2659" data-mp="tk7zdjwihfq9">
                  0{index + 1}
                </div>
                <h3 className="font-bold text-[#111827] text-xl mb-3" data-id="element-2660" data-mp="5ssqf8a8c061">
                  {step.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-2661" data-mp="asoz3ktvgfrx">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-20 md:py-24 relative overflow-hidden" data-id="element-2662" data-mp="ki8gsn5um3l7">
        <div className="absolute inset-0 bg-[radial-gradient(rgba(255,255,255,0.1)_1px,transparent_1px)] [background-size:24px_24px] opacity-30" data-id="element-2663" data-mp="3j770x4t7yz33"></div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-2664" data-mp="1672sgi2wfxfw">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2665" data-mp="126ivbeibsttr">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-white mb-6 text-3xl md:text-4xl lg:text-5xl" data-id="element-2666" data-mp="1283rt9o7amu9">
              Klaar om te solliciteren?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-white text-opacity-90 text-lg md:text-xl leading-relaxed mb-10" data-id="element-2667" data-mp="1l5epwqy3ja84">
              Stuur je CV en motivatie naar ons op. We nemen binnen 2 werkdagen
              contact met je op.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-2668" data-mp="2nh6e2kleggii">
              <a href="mailto:sollicitatie@noorddigital.nl" className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-bold rounded-xl hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl w-full sm:w-auto justify-center" data-id="element-2669" data-mp="2ihaa2lcpcp2y">
                <MailIcon className="mr-2 h-5 w-5" data-id="element-2670" data-mp="28l6xelk8581r" />
                Solliciteer direct
              </a>
              <a href="/websites" className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-xl hover:bg-white hover:text-[#007AFF] transition-all w-full sm:w-auto justify-center" data-id="element-2671" data-mp="1uqeah2208pl5">
                Bekijk onze diensten
              </a>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer data-id="element-2672" data-mp="1oxqzi4gd2cjc" />
    </div>;
};